import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const TextMaskCustom = (props) => {
  const { inputRef, mask, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={mask}
      showMask
      guide={false}
    />
  );
};

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

TextMaskCustom.defaultProps = {
  mask: ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
};

const TextMaskDocument = (props) => {
  const { inputRef, maskOptions, ...other } = props;

  const docMask = createNumberMask({
    ...defaultMaskOptions,
    ...maskOptions,
  });

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={docMask}
      showMask
      guide={false}
    />
  );
};

const defaultMaskOptions = {
  prefix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: false,
  decimalSymbol: '.',
  allowNegative: false,
  integerLimit: 10,
  decimalLimit: 0,
};

TextMaskDocument.propTypes = {
  inputRef: PropTypes.func.isRequired,
  maskOptions: PropTypes.shape({
    prefix: PropTypes.string,
    includeThousandsSeparator: PropTypes.bool,
    thousandsSeparatorSymbol: PropTypes.string,
    allowDecimal: PropTypes.bool,
    decimalSymbol: PropTypes.string,
    allowNegative: PropTypes.bool,
    decimalLimit: PropTypes.string,
    integerLimit: PropTypes.number,
  }),
};

TextMaskDocument.defaultProps = {
  inputMode: 'numeric',
  maskOptions: {},
};

export { TextMaskCustom, TextMaskDocument };
